"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpelledOrganization = exports.makeAccepters = exports.acceptFormFocusableClassname = exports.focusFirstAcceptFlowElement = exports.getAcceptFormDisabledMessage = exports.AcceptFormDisabledReason = exports.mapPrefillData = exports.getBillingTotals = exports.getPaymentDetails = exports.transformAndCleanFormData = void 0;
var CleanJson_1 = __importDefault(require("@CommonFrontend/CleanJson/CleanJson"));
var lodash_1 = require("lodash");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var GetLetter_1 = require("../GroupAccept/GetLetter");
var transformAndCleanFormData = function (formData, settings, prefillData) {
    var _a;
    var acceptanceData;
    if (settings.customForm) {
        var customDetailsKeys = settings.customForm.fields.map(function (field) { return field.id; });
        acceptanceData = (0, lodash_1.omit)(formData, customDetailsKeys);
        var customForm = settings.customForm.fields.map(function (field) {
            var _a, _b;
            return {
                id: field.id,
                field: field.name,
                value: (_b = (_a = formData[field.id]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "",
            };
        });
        acceptanceData.customFormId = settings.customForm.id;
        acceptanceData.customForm = (0, CleanJson_1.default)(customForm);
        acceptanceData.usedCustomForm = true;
    }
    else {
        acceptanceData = formData;
    }
    if (((_a = settings.organizationField) === null || _a === void 0 ? void 0 : _a.show) === false && !acceptanceData.legalEntity) {
        acceptanceData.legalEntity = "";
    }
    if (prefillData && prefillData.name) {
        acceptanceData.isPrefilled = prefillData.name.source === "blockSettings";
    }
    else {
        acceptanceData.isPrefilled = false;
    }
    acceptanceData = (0, lodash_1.omit)(acceptanceData, ["cardName", "cardZip", "cardNumber", "cardCvc", "cardExpiry"]);
    return acceptanceData;
};
exports.transformAndCleanFormData = transformAndCleanFormData;
var getPaymentDetails = function (paymentSettings, projectCurrencies, quoteTotal) {
    var getCurrencyCode = function () {
        try {
            return projectCurrencies.getSingleCurrency();
        }
        catch (error) {
            return "AUD";
        }
    };
    var partialPaymentPercentage = undefined;
    var paymentAmount = quoteTotal || 0;
    var isPartialPayment = false;
    if ((paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.partialPaymentConfig.enabled) && paymentSettings.partialPaymentConfig.amount) {
        isPartialPayment = true;
        var _a = paymentSettings.partialPaymentConfig, kind = _a.kind, amount = _a.amount;
        if (kind === "percentage") {
            partialPaymentPercentage = Math.max(Math.min(amount, 100), 0.1);
            paymentAmount = (quoteTotal * partialPaymentPercentage) / 100;
        }
        else if (kind === "fixed") {
            paymentAmount = Math.min(amount, quoteTotal);
        }
    }
    return {
        currencyCode: getCurrencyCode(),
        paymentAmount: paymentAmount,
        isPartialPayment: isPartialPayment,
        partialPaymentPercentage: partialPaymentPercentage,
    };
};
exports.getPaymentDetails = getPaymentDetails;
var getBillingTotals = function (billingSummary) {
    var _a;
    var _b, _c;
    return (_a = {},
        _a["one-off"] = (_c = (_b = billingSummary.total["one-off"]) === null || _b === void 0 ? void 0 : _b.billable) !== null && _c !== void 0 ? _c : 0,
        _a.recurring = Object.entries(billingSummary.total)
            .filter(function (_a) {
            var _b = __read(_a, 1), frequency = _b[0];
            return frequency !== "one-off";
        })
            .reduce(function (sum, _a) {
            var _b = __read(_a, 2), _ = _b[0], total = _b[1];
            return sum + total.billable;
        }, 0),
        _a);
};
exports.getBillingTotals = getBillingTotals;
var mapPrefillData = function (_a) {
    var springboardData = _a.springboardData, blockSettings = _a.blockSettings;
    var name = (blockSettings === null || blockSettings === void 0 ? void 0 : blockSettings.name)
        ? { value: blockSettings.name, source: "blockSettings" }
        : (springboardData === null || springboardData === void 0 ? void 0 : springboardData.legalName)
            ? { value: springboardData.legalName, source: "springboard" }
            : undefined;
    if (springboardData) {
        var data = __assign(__assign(__assign(__assign({}, (0, CommonUtils_1.includeIf)(!!(springboardData === null || springboardData === void 0 ? void 0 : springboardData.email), {
            email: { value: springboardData.email, source: "springboard" },
        })), (0, CommonUtils_1.includeIf)(!!(springboardData === null || springboardData === void 0 ? void 0 : springboardData.signature), {
            esignature: { value: springboardData.signature, source: "springboard" },
        })), (0, CommonUtils_1.includeIf)(!!(springboardData === null || springboardData === void 0 ? void 0 : springboardData.organisation), {
            legalEntity: { value: springboardData.organisation, source: "springboard" },
        })), (0, CommonUtils_1.includeIf)(!!name, { name: name }));
        return data;
    }
    return __assign({}, (0, CommonUtils_1.includeIf)(!!name, { name: name }));
};
exports.mapPrefillData = mapPrefillData;
var AcceptFormDisabledReason;
(function (AcceptFormDisabledReason) {
    AcceptFormDisabledReason["RequiresQuote"] = "requiresQuote";
    AcceptFormDisabledReason["CollaboratorPage"] = "collaboratorPage";
    AcceptFormDisabledReason["TemplateGallery"] = "templateGallery";
})(AcceptFormDisabledReason || (exports.AcceptFormDisabledReason = AcceptFormDisabledReason = {}));
var getAcceptFormDisabledMessage = function (reason) {
    var _a;
    return (_a = {},
        _a[AcceptFormDisabledReason.CollaboratorPage] = collaboratorDisabledMessage,
        _a[AcceptFormDisabledReason.TemplateGallery] = templateGalleryDisabledMessage,
        _a[AcceptFormDisabledReason.RequiresQuote] = requiresQuoteDisabledMessage,
        _a)[reason];
};
exports.getAcceptFormDisabledMessage = getAcceptFormDisabledMessage;
var collaboratorDisabledMessage = "This page is for internal collaboration only - use the Shareable Link to allow clients to accept";
var templateGalleryDisabledMessage = "Cannot accept a template page.";
var requiresQuoteDisabledMessage = "Please select an option in the quote to accept this page";
var focusFirstAcceptFlowElement = function () {
    var firstFocusable = document.getElementsByClassName(exports.acceptFormFocusableClassname)[0];
    if (firstFocusable) {
        var wrappedInput = firstFocusable.querySelector("input");
        var elementToFocus = !!wrappedInput ? wrappedInput : firstFocusable;
        elementToFocus.focus({ preventScroll: true });
    }
};
exports.focusFirstAcceptFlowElement = focusFirstAcceptFlowElement;
exports.acceptFormFocusableClassname = "accept-form-focusable";
var makeAccepters = function (totalAccepterCount, finalisedAccepters, prefillSettings) {
    var prefilledNames = prefillSettings.enabled && prefillSettings.names ? prefillSettings.names : [];
    var remainingFinalisedAcceptersWithoutPrefill = finalisedAccepters.filter(function (accepter) { return accepter.name && !prefilledNames.includes(accepter.name); });
    if (finalisedAccepters.length > totalAccepterCount) {
        throw new Error("Too many finalised accepters");
    }
    var slots = [];
    prefilledNames.forEach(function (name, index) {
        if (!!name) {
            var finalisedAccepter = finalisedAccepters.find(function (fa) { return fa.name && fa.name === name; });
            if (finalisedAccepter) {
                slots.push(convertFinalisedAccepter(finalisedAccepter));
            }
            else {
                slots.push(createOpenSlot(name));
            }
        }
        else {
            if (remainingFinalisedAcceptersWithoutPrefill.length > 0) {
                slots.push(convertFinalisedAccepter(remainingFinalisedAcceptersWithoutPrefill.shift()));
            }
            else {
                slots.push(createOpenSlot("Accepter ".concat((0, GetLetter_1.getLetter)(index))));
            }
        }
    });
    remainingFinalisedAcceptersWithoutPrefill.forEach(function (accepter) {
        slots.push(convertFinalisedAccepter(accepter));
    });
    var offset = slots.length;
    for (var i = offset; i < totalAccepterCount; i++) {
        slots.push(createOpenSlot("Accepter ".concat((0, GetLetter_1.getLetter)(i))));
    }
    return slots;
};
exports.makeAccepters = makeAccepters;
var convertFinalisedAccepter = function (finalisedAccepter) {
    var _a, _b, _c;
    return {
        isAccepted: true,
        name: (_a = finalisedAccepter.name) !== null && _a !== void 0 ? _a : "",
        signature: (_b = finalisedAccepter.esignature) !== null && _b !== void 0 ? _b : "",
        initials: (_c = finalisedAccepter.einitials) !== null && _c !== void 0 ? _c : "",
        acceptedAt: finalisedAccepter.acceptedAt,
    };
};
var createOpenSlot = function (name) {
    return {
        isAccepted: false,
        name: name,
        signature: "",
        initials: "",
        acceptedAt: "",
    };
};
var getSpelledOrganization = function (organizationField) {
    if ((organizationField === null || organizationField === void 0 ? void 0 : organizationField.language) === "UK")
        return "Organisation";
    return "Organization";
};
exports.getSpelledOrganization = getSpelledOrganization;
